import './globals'
import './utils/sugar'
import VueFire from 'vuefire'
import Vue from 'vue'
import App from './App.vue'
import components from './components'
import router from './router.js'

import translationMixin from './mixins/translation'


import './utils/vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faChevronLeft, faChevronRight, faPlus, faCog, faPen, faTrash, faTimes, faChevronDown, faChevronUp, faSave, faExpand, faSignOutAlt, faImage, faVideo, faEnvelope, faBlog, faClone, faCalendarDay, faMinus, faSearch, faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faFacebookF, faCheck, faChevronLeft, faChevronRight, faTwitter, faInstagram, faLinkedinIn, faYoutube, faPlus, faCog, faPen, faTrash, faTimes, faChevronDown, faChevronUp, faSave, faExpand, faSignOutAlt, faImage, faVideo, faEnvelope, faBlog, faClone, faCalendarDay, faMinus, faSearch, faCaretDown, faCaretUp)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.mixin(translationMixin)

Vue.use(components)
Vue.use(VueFire)


window.vm = new Vue({
  router,
  ...App,
}).$mount('#app')

export default window.vm
